import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { confirmDialog } from '../utils/confirm';

const EMPTY = { name: '', capacity: '' };

export default function Rooms() {
  const [rows, setRows] = useState([]);
  const [modal, setModal] = useState(null);

  function load() { api.get('/catalog/rooms').then(setRows).catch(() => {}); }
  useEffect(load, []);

  async function del(r) {
    if (!await confirmDialog(`Supprimer la salle "${r.name}" ?`)) return;
    await api.delete(`/catalog/rooms/${r.id}`);
    load();
  }

  return (
    <div className="page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Salles de classe</h1>
        <button className="btn" onClick={() => setModal(EMPTY)} style={{ width: 'auto', padding: '0 18px' }}>+ Ajouter</button>
      </div>

      <table className="table">
        <thead><tr><th>Nom</th><th>Capacité</th><th></th></tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={3} style={{ textAlign: 'center', color: 'var(--muted)' }}>Aucune salle</td></tr>}
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{r.name}</td>
              <td>{r.capacity ?? '—'}</td>
              <td style={{ textAlign: 'right', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button className="btn-ghost" onClick={() => setModal(r)}>Modifier</button>
                <button className="btn-ghost" style={{ color: 'var(--danger)' }} onClick={() => del(r)}>Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modal && <RoomModal initial={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
    </div>
  );
}

function RoomModal({ initial, onClose, onSaved }) {
  const isEdit = !!initial.id;
  const [f, setF] = useState({ name: initial.name || '', capacity: initial.capacity ?? '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  async function submit(e) {
    e.preventDefault(); setError(''); setSaving(true);
    const payload = { name: f.name, capacity: f.capacity !== '' ? Number(f.capacity) : undefined };
    try {
      if (isEdit) await api.patch(`/catalog/rooms/${initial.id}`, payload);
      else await api.post('/catalog/rooms', payload);
      onSaved();
    } catch (err) { setError(err.message); setSaving(false); }
  }

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2 style={{ fontFamily: 'Space Grotesk, sans-serif', marginBottom: 16 }}>{isEdit ? 'Modifier la salle' : 'Nouvelle salle'}</h2>
        {error && <div className="form-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="field"><label>Nom *</label><input value={f.name} onChange={set('name')} required /></div>
          <div className="field"><label>Capacité</label><input type="number" min="1" value={f.capacity} onChange={set('capacity')} placeholder="Ex: 40" /></div>
          <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
            <button className="btn" type="submit" disabled={saving} style={{ width: 'auto', padding: '0 22px' }}>{saving ? 'Enregistrement…' : isEdit ? 'Enregistrer' : 'Créer'}</button>
            <button className="btn-ghost" type="button" onClick={onClose}>Annuler</button>
          </div>
        </form>
      </div>
    </div>
  );
}
